class ShapeFilter extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.shape-filter-pills__btn');
    this.variantGrids = this.querySelectorAll('.shape-variant-grid');
    this.filtersAdjacent = this.closest('.filters-adjacent');
    this.productGrid = this.filtersAdjacent
      ? this.filtersAdjacent.querySelector('.product-grid')
      : null;
    this.paginationRow = document.querySelector('.pagination-row');
  }

  connectedCallback() {
    this.buttons.forEach((btn) => {
      btn.addEventListener('click', (e) => this.handleFilter(e));
    });

    // Check URL for initial shape filter
    const params = new URLSearchParams(window.location.search);
    const shape = params.get('shape');
    if (shape) {
      const btn = this.querySelector(`[data-shape="${shape}"]`);
      if (btn) btn.click();
    }
  }

  handleFilter(e) {
    const btn = e.currentTarget;
    const shape = btn.dataset.shape;

    // Update active button
    this.buttons.forEach((b) =>
      b.classList.remove('shape-filter-pills__btn--active')
    );
    btn.classList.add('shape-filter-pills__btn--active');

    // Update URL without reload
    const url = new URL(window.location);
    if (shape === 'all') {
      url.searchParams.delete('shape');
    } else {
      url.searchParams.set('shape', shape);
    }
    history.replaceState(null, '', url);

    if (shape === 'all') {
      // Show product grid, hide variant grids
      if (this.productGrid) this.productGrid.style.display = '';
      if (this.paginationRow) this.paginationRow.style.display = '';
      this.variantGrids.forEach((g) =>
        g.classList.remove('shape-variant-grid--active')
      );
    } else {
      // Hide product grid, show matching variant grid
      if (this.productGrid) this.productGrid.style.display = 'none';
      if (this.paginationRow) this.paginationRow.style.display = 'none';
      this.variantGrids.forEach((g) => {
        if (g.dataset.shape === shape) {
          g.classList.add('shape-variant-grid--active');
        } else {
          g.classList.remove('shape-variant-grid--active');
        }
      });
    }
  }
}

customElements.define('shape-filter', ShapeFilter);
